var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 91,
    viewBox: "0 0 57 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vectors"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0885 9.04933H10.872C9.95371 9.04933 9.41251 8.03257 9.90451 7.27819L13.5616 1.68599C14.4635 0.308445 16.4807 0.308445 17.3826 1.68599L21.0397 7.27819C21.5317 8.04897 20.9905 9.04933 20.0722 9.04933H20.0885Z",
    fill: "#236F5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.9778 22.6116V26.1538H23.5492C20.1545 26.1538 17.3994 28.9089 17.3994 32.3036V82.8466H1V22.6116L8.7569 10.7876H22.2209L29.9778 22.6116Z",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M55.5105 32.3034V54.4918H29.9766V26.1372H49.3607C52.7554 26.1372 55.5105 28.8923 55.5105 32.287V32.3034Z",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M51.7559 58.5757H40.5224C37.9149 65.4142 38.456 74.6143 38.456 74.6143C35.3729 69.1369 35.8814 62.1671 36.4553 58.5757H33.0114C33.0114 58.5757 29.3052 64.6926 30.3875 72.9743C31.4863 81.2725 40.6372 86.2907 42.3919 90.6529C44.1303 86.2907 53.2976 81.2725 54.3963 72.9743C55.4951 64.6762 51.7723 58.5757 51.7723 58.5757H51.7559Z",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferSvg1);
export default __webpack_public_path__ + "static/media/offer-svg-1.eb4d7e34211064d936d8a3433c26c5e8.svg";
export { ForwardRef as ReactComponent };